<template>
  <div class="preview-dialog">
    <el-dialog
      :title="$t('lcd.material.auditObj.title')"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <div class="cont">
        <div class="imgWrap">
          <video
            controls
            autoplays
            v-if="auditObj.format == 'mp4'"
            :src="auditObj.originalUrl"
          ></video>
          <el-image
            :src="auditObj.originalUrl"
            class="materialImage"
            fit="contain"
            v-else
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>
        <el-descriptions
          size="medium"
          :column="1"
          class="imgInfo"
          :title="$t('lcd.material.Material Info')"
        >
          <el-descriptions-item :label="$t('lcd.material.Material Name')">{{
            auditObj.materialName
          }}</el-descriptions-item>
          <el-descriptions-item :label="$t('lcd.Template.Template No')">{{
            auditObj.materialId
          }}</el-descriptions-item>
          <el-descriptions-item label="素材分组">{{
            auditObj.groupId == 0
              ? $t("lcd.material.ItemMaterial")
              : $t("lcd.material.MarketMaterial")
          }}</el-descriptions-item>
          <el-descriptions-item :label="$t('lcd.Template.Resolution')">{{
            auditObj.pixels
          }}</el-descriptions-item>
          <el-descriptions-item label="格式">
            <el-tag size="small" type="success">{{ auditObj.format }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="时长" v-if="auditObj.format == 'mp4'">{{
            auditObj.duration
          }}</el-descriptions-item>
        </el-descriptions>
        <el-form
          class="auditForm"
          label-position="top"
          ref="form"
          :model="form"
          :rules="rules"
          style="text-align: left"
        >
          <el-form-item
            :label="$t('lcd.material.Audit State')"
            prop="auditState"
          >
            <el-radio-group v-model="form.auditState">
              <el-radio :label="1">{{ $t("lcd.material.Audit Yes") }}</el-radio>
              <el-radio :label="2">{{ $t("lcd.material.Audit No") }}</el-radio>
            </el-radio-group>
            <div class="reasonList" v-if="form.auditState == 2">
              <el-tag
                @click="addReason($t('lcd.material.Material Name Too Long'))"
                type="danger"
                size="mini"
                >{{ $t("lcd.material.Material Name Too Long") }}</el-tag
              >
              <el-tag
                @click="addReason($t('lcd.material.The Material Contains Sensitive Information'))"
                type="danger"
                size="mini"
                >{{$t('lcd.material.The Material Contains Sensitive Information')}}</el-tag
              >
              <el-tag @click="addReason($t('lcd.material.Pixel Mismatch'))" type="danger" size="mini"
                >{{$t('lcd.material.Pixel Mismatch')}}</el-tag
              >
              <el-tag @click="addReason($t('lcd.material.Format Mismatch'))" type="danger" size="mini"
                >{{$t('lcd.material.Format Mismatch')}}</el-tag
              >
            </div>
            <el-input
              type="textarea"
              resize="none"
              :autosize="{ minRows: 4, maxRows: 5 }"
              :placeholder="$t('lcd.material.Please Input Audit No Reason')"
              v-model="form.auditNote"
              v-if="form.auditState == 2"
            >
            </el-input>
          </el-form-item>
          <div class="form-btn-section">
            <el-button color="#28C76F" size="small" @click="handleClose">
              {{ $t("button.Cancel") }}</el-button
            >
            <el-button
              color="#28C76F"
              size="small"
              type="success"
              @click="onSubmit"
              >{{ $t("button.Save") }}</el-button
            >
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { auditMaterial } from "@/libs/api/lcd";
export default {
  name: "ConfirmDialog",
  data() {
    return {
      reasonList: [],
      form: {
        auditState: "",
        auditNote: "",
      },
      rules: {
        auditState: [
          { required: true, message: "请选择审核状态", trigger: "change" },
        ],
      },
    };
  },
  props: {
    dialogVisible: {
      type: Boolean,
      required: true,
    },
    auditObj: {
      type: Object,
      default: null,
    },
  },
  watch: {
    reasonList: {
      handler: function (val, oval) {
        console.log(val);
        this.form.auditNote = val.join(",");
      },
      deep: true,
    },
  },
  methods: {
    handleClose(val) {
      this.$emit("handleClose", val);
      this.$refs["form"].resetFields();
      this.form = {
        auditState: "",
        auditNote: "",
      };
    },
    indexOf(val, ids) {
      for (let i = 0; i < ids.length; i++) {
        if (ids[i] == val) {
          return i;
        }
      }
      return -1;
    },
    addReason(val) {
      let index = this.indexOf(val, this.reasonList);
      if (this.reasonList.length > 0 && index > -1) {
        // 删除选中的原因
        this.reasonList.splice(index, 1);
      } else {
        this.reasonList.push(val);
      }
    },
    onSubmit() {
      // TODO请求审核接口
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.auditNote || this.form.auditState == 1) {
            console.log(this.form);
            let params = {
              materialId: this.auditObj.materialId,
              ...this.form,
            };
            auditMaterial(params).then((res) => {
              console.log(res);

              if (res.data.code == 1) {
                this.$message.success(this.$t("lcd.material.Audit Success"));
                this.$refs["form"].resetFields();
                this.form = {
                  auditState: "",
                  auditNote: "",
                };
                this.$emit("reGetList");
              } else {
                this.$refs["form"].resetFields();
                this.$message.error(res.data.message);
              }
            });
          } else {
            this.$message.error(
              this.$t("lcd.material.Please Input Audit No Reason")
            );
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.preview-dialog ::v-deep {
  color: #35b871;
  .el-dialog__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .el-dialog {
    height: 600px;
    border-radius: 6px;
    width: 1100px;
    margin-top: 0 !important;
    margin: 0 !important;
  }
  ::v-deep .el-dialog__body {
    padding: 0 !important;
  }
  .cont {
    width: 100%;
    text-align: center;
    height: 510px;
    .imgWrap {
      width: 600px;
      height: 490px;
      position: relative;
      background-color: #f5f5f5;
      border-radius: 4px;
      float: left;
      .materialImage,
      video {
        display: block;
        margin: 0 auto;
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .imgInfo,
    .auditForm {
      width: 430px;
      float: right;
      .reasonList {
        line-height: 36px;
        .el-tag {
          margin-right: 8px;
          cursor: pointer;
        }
      }
    }
    .auditForm .el-form-item__label {
      padding: 0;
      line-height: 30px;
    }

    .icon {
      display: flex;
      justify-content: center;
      color: #ff9600;
    }
    ::v-deep .el-icon-warning-outline {
      font-size: 46px;
    }
    .text {
      margin-top: 16px;
      display: inline-block;
      // color: #FF9600;
    }
  }
  .cancel,
  .confirm {
    cursor: pointer;
    width: 50%;
    position: absolute;
    bottom: 0;
    height: 50px;
    line-height: 50px;
    border-top: 1px solid #e6e6e6;
    vertical-align: center;
  }
  .cancel {
    border-right: 1px solid #e6e6e6;
    left: 0;
    color: #333333;
  }
  .confirm {
    right: 0;
    color: #35b871;
  }
  .form-btn-section {
    position: absolute;
    right: 20px;
    bottom: 30px;
  }
}
</style>